import { Component, inject, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TimesheetFilterComponent } from '../timesheet-filter/timesheet-filter.component';
import { CommonModule } from '@angular/common';
import { ListTableComponent } from '../../../../shared/components/list-table/list-table.component';
import { NgZorroModule } from '../../../../shared/modules/ng-zorro/ng-zorro.module';
import { TableRowActions } from '../../../../shared/interfaces/actions';
import { TableRowActionsModel } from '../../../../shared/interfaces/list.interface';
import { LookupService } from '../../../../services/lookup.service';
import { ListService } from '../../../../shared/services/list.service';
import { DateTimeFormatterService } from '../../../../shared/utils/date-time-formatter.service';
import { TimesheetStaffErrorcodeComponent } from "../timesheet-staff-errorcode/timesheet-staff-errorcode.component";
import { DialogConfig, DialogService } from '../../../../shared/services/dialog.service';
import { PopupDialogComponent } from '../../../../shared/components/popup-dialog/popup-dialog.component';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { TimesheetService } from '../../../../services/timesheet.service';
import { ENDPOINTS } from '../../../../shared/constants/url.constants';
import { ErrorAlertService } from '../../../../shared/services/error-alert.service';
import { NzFormDirective } from 'ng-zorro-antd/form';
import { SharedDataService } from '../../../../shared/services/shared-data-service';
import { UserService } from '../../../../services/user.service';
import CommonUtil from '../../../../shared/authorization/common.util';
import { AuthorizationUtility } from '../../../../shared/authorization/auth.utility';
import { AuthorizationService } from '../../../../shared/authorization/authorization.service';
import { PageConfig } from '../../../../shared/authorization/auth.config';
import { PAGE_CONSTANTS } from '../../../../shared/constants/page.constants';
import { DropdownSelectComponent } from '../../../../shared/components/dropdown-select/dropdown-select.component';
import { MultiselectComponent } from '../../../../shared/components/multiselect/multiselect.component';
import { AutoFocusHeaderDirective } from '../../../../shared/directives/auto-focus-header.directive';
import { NotificationService } from '../../../../shared/services/notification.service';

@Component({
  selector: 'ppl-timesheet-pended-list',
  standalone: true,
  imports: [ListTableComponent,
    NgZorroModule,
    CommonModule,
    TimesheetFilterComponent,
    TimesheetStaffErrorcodeComponent,
    PopupDialogComponent,
    FormsModule,
    NzFormDirective,
    ReactiveFormsModule,
    DropdownSelectComponent,
    MultiselectComponent,
    AutoFocusHeaderDirective
  ],
  templateUrl: './timesheet-pended-list.component.html',
  styleUrl: './timesheet-pended-list.component.css'
})
export class TimesheetPendedListComponent {
  pageId: string = PAGE_CONSTANTS.STAFF_PENDED_TIMESHEETS;
  
  @ViewChild(ListTableComponent) childComponent!: ListTableComponent;
  @ViewChild(TimesheetFilterComponent) timesheetFilterChildComponent!: TimesheetFilterComponent;
  @ViewChild('pendedDialog') pendedDialog!: TemplateRef<any>;
  @ViewChild('confirmationDialog') confirmationDialog!: TemplateRef<any>;
  @ViewChild('warningDialog') warningDialog!: TemplateRef<any>;
  @ViewChild('historyDialog') historyDialog!: TemplateRef<any>;

  private dialogSvc = inject(DialogService);

  actionButtons: TableRowActionsModel = new TableRowActions({ view: false, history: true });
  appliedFilters: any;
  programName!: string;
  processingStatusList: any;
  reasonList: any;
  overrideReasonList: any;
  denyReasonList: any;
  businessStatusList: any;
  timesheets: any[] = [];
  pendedDialogId: any;
  errorcodeData: any;
  title: string = '';
  okText: string = '';
  placeholder: string = '';
  showActionPopup: boolean = false;
  buttonActionEvent: any;
  selectedCheckboxes: any;
  processCodes: any[] = [];
  pendCodes: any[] = [];
  allowedProcessCodes: any[] = [];
  totalTimesheetsEffected = 0;
  timesheetActionForm!: FormGroup;
  disableEditingPendedTimesheet = false;
  isAssignToUser = false;
  userList: any = null;
  listOfUsers: string[] = [];
  selectedUsers: string[] = [];
  timesheetHistoryData: any;

  private readonly denyAllowedStatuses = ['SB', 'PE', 'SE', 'TP'];
  private readonly overrideAllowedStatuses = [ 'PE', 'SE', 'TP'];

  cols = [
    {
      field: 'timesheetLineId',
      header: 'Timesheet \nNumber',
      jsonpath: 'timesheetLineId',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'payPeriod',
      header: 'Pay \nPeriod',
      jsonpath: 'payPeriod',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'serviceDate',
      header: 'Service \nDate',
      jsonpath: 'serviceDate',
      isDisplayedAtHeader: 'y',
      isSearchable: 'y',
    },
    {
      field: 'createdDate',
      header: 'Submission \nDate',
      jsonpath: 'createdDate',
      isDisplayedAtHeader: 'y',
      isSearchable: 'y',
    },
    {
      field: 'sourceType',
      header: 'Submission \nSource',
      jsonpath: 'sourceType',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'approvalSourceType',
      header: 'Approval \nSource',
      jsonpath: 'approvalSourceType',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'consumerName',
      header: 'Consumer \nName',
      jsonpath: 'consumerName',
      isDisplayedAtHeader: 'y',
      isSearchable: 'y',
    },
    {
      field: 'consumerPPLId',
      header: 'Consumer \nPPL ID',
      jsonpath: 'consumerPPLId',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
      isClickable: true
    },
    {
      field: 'providerPPLId',
      header: 'PA PPL ID',
      jsonpath: 'providerPPLId',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
      isClickable: true
    },
    {
      field: 'applicationStatus',
      header: 'Application \nStatus',
      jsonpath: 'applicationStatus',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'processStatus',
      header: 'Processing \nStatus',
      jsonpath: 'processStatus',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'serviceDesc',
      header: 'Service \nDescription',
      jsonpath: 'serviceDesc',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'timeInTimeOut',
      header: 'Time In - \nTime Out',
      jsonpath: 'timeInTimeOut',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'billedUnit',
      header: 'Billed Units \n(15 Mins \nIncrement)',
      jsonpath: 'billedUnit',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'billedUnitInHours',
      header: 'Billed \nUnits \n(hrs)',
      jsonpath: 'billedUnitInHours',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'billRate',
      header: 'Service \nRate',
      jsonpath: 'billRate',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'assignToName',
      header: 'Assignee',
      jsonpath: 'assignToName',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'lastAssignDate',
      header: 'Assignment Date',
      jsonpath: 'lastAssignDate',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    }
  ];

  timesheetHistoryCols = [
    {
      field: 'processingStatusDisplay',
      header: 'Processing Status',
      jsonpath: 'processingStatusDisplay',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'businessStatusDisplay',
      header: 'Business Status',
      jsonpath: 'businessStatusDisplay',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'modifiedDate',
      header: 'Modified Date',
      jsonpath: 'modifiedDate',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'modifiedBy',
      header: 'Modified By',
      jsonpath: 'modifiedBy',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    }
  ];

  buttons = [
    {
      button_id: "Override",
      button_label: "Override",
      buttonAction: "overrideTimesheet",
      className: "primary-btn-color"
    },
    {
      button_id: "OverrideAll",
      button_label: "Override All",
      buttonAction: "overrideAllTimesheets",
      className: "primary-btn-color"
    },
    {
      button_id: "Deny",
      button_label: "Deny",
      buttonAction: "denyTimesheet",
      className: "primary-btn-color"
    },
    {
      button_id: "DenyAll",
      button_label: "Deny All",
      buttonAction: "denyAllTimesheet",
      className: "primary-btn-color"
    },
    {
      button_id: "submitForProcessing",
      button_label: "Submit For Processing",
      buttonAction: "submitForProcessing",
      className: "primary-btn-color"
    },
    {
      button_id: "assignToUser",
      button_label: "Assign to User",
      buttonAction: "assignToUser",
      className: "primary-btn-color"
    },
  ]

  fields = [
    { field: 'Timeframe', show: true, default: '30 days', extendedMonths: true, extendedYear: true, extendedYearMax540: true, skipServicePeriodValidation: true },
    { field: 'consumer', show: true },
    { field: 'consumerPplId', show: true },
    { field: 'provider', show: true },
    { field: 'providerPplId', show: true },
    { field: 'payPeriod', show: true },
    { field: 'paymentDate', show: true },
    { field: 'processStatusLkup', show: true, default: 'PE' },
    { field: 'serviceCode', show: true },
    { field: 'processCode', show: true },
    { field: 'serviceDate', show: true },
    { field: 'assignedTo', show: true },
  ];

  keyMapping: { [key: string]: string } = {
    Timeframe: "serviceDuration",
    payPeriod: "serviceId",
    consumer: "consumerName",
    provider: "providerName",
    providerPplId: "providerPPLId",
    consumerPplId: "consumerPPLId",
    processStatusLkup: "processStatus",
    paymentDate: "paymentId",
    assignedTo: "assignToName"
  };

  columnsToBeHidden: string[] = [];
  actionsToBeHidden: string[] = [];
  isPageRestrictionLoaded = false;
  isReadOnly = false;
  filterInitialValues: Record<string, unknown> = {};

  constructor(
    private listService: ListService,
    private fb: FormBuilder,
    private lookupService: LookupService,
    private dateTimeFormatterService: DateTimeFormatterService,
    private timesheetService: TimesheetService,
    private errorAlertService: ErrorAlertService,
    private sharedDataService: SharedDataService,
    private userService: UserService,
    private authUtility: AuthorizationUtility,
    private authService: AuthorizationService,
    private route: ActivatedRoute,
    private notificationService: NotificationService
  ) { }

  ngOnInit(): void {
    this.timesheetActionForm = this.fb.group({
      selectedProcessCode: [null, [Validators.required]],
      reason: [null, [Validators.required]],
      comments: [null, [Validators.required, Validators.maxLength(10000)]],
    });

    const selectedProgram = this.userService.getSelectedProgram();
    this.programName = selectedProgram?.program_code ?? '';
    this.businessStatusList = this.lookupService.getLookupValue('Business Status');
    this.processingStatusList = this.lookupService.getLookupValue('TS_App_S');
    this.overrideReasonList = this.lookupService.getLookupValue('Override Disposition Reason');
    this.denyReasonList = this.lookupService.getLookupValue('Deny Disposition Reason');
    const canSeeConsumerNonResponsive = this.userService.isSelectedRole(['PPL Admin', 'BAVAdmin', 'Compliance', 'Fulfillment Staff']);
    if (!canSeeConsumerNonResponsive) {
      this.overrideReasonList = this.overrideReasonList.filter((r: any) => r.lkpValueName !== 'Consumer Non-Responsive');
      this.denyReasonList = this.denyReasonList.filter((r: any) => r.lkpValueName !== 'Consumer Non-Responsive');
    }
    this.setPageAccess();
    this.getProcessCodes();
    this.loadAssignableUsers();
    this.checkOverrideAllowConfig();

    const qp = this.route.snapshot.queryParams;
    if (qp['providerPPLId'] || qp['consumerPPLId'] || qp['processStatus']) {
      this.filterInitialValues = {
        Timeframe: null,
        ...(qp['providerPPLId'] && { providerPplId: qp['providerPPLId'] }),
        ...(qp['consumerPPLId'] && { consumerPplId: qp['consumerPPLId'] }),
        ...(qp['processStatus'] && { processStatusLkup: qp['processStatus'] }),
        ...(qp['servicePeriodId'] && { payPeriod: +qp['servicePeriodId'] }),
      };

      const filters: { jsonPath: string; value: string; operator: string }[] = [];
      if (qp['servicePeriodId']) {
        filters.push({ jsonPath: 'serviceId', value: qp['servicePeriodId'], operator: 'Equal' });
      }
      if (qp['providerPPLId']) {
        filters.push({ jsonPath: 'providerPPLId', value: qp['providerPPLId'], operator: 'Equal' });
      }
      if (qp['consumerPPLId']) {
        filters.push({ jsonPath: 'consumerPPLId', value: qp['consumerPPLId'], operator: 'Equal' });
      }
      if (qp['processStatus']) {
        filters.push({ jsonPath: 'processStatus', value: qp['processStatus'], operator: 'Equal' });
      }
      this.searchTimesheets(filters);
    }
  }

  private getAssignToSearchValue(selectedName: string): string {
    const match = this.userList?.responsedata?.find(
      (user: any) => `${user.firstName} ${user.lastName}` === selectedName
    );
    return match ? `${match.lastName}, ${match.firstName}` : selectedName;
  }

  loadAssignableUsers() {
    this.timesheetService.getUserList(this.programName).subscribe((data: { responsedata: { firstName: string; lastName: string }[] }) => {
      this.userList = data;
      this.listOfUsers = data.responsedata.map(
        (user: { firstName: string; lastName: string }) => `${user.firstName} ${user.lastName}`
      );
    });
  }

  private checkOverrideAllowConfig() {
    this.timesheetService.getTimesheetConfig(this.programName).subscribe({
      next: (res) => {
        const overrideAllow = res?.responsedata?.['timesheet.override.allow'];
        const allowedEmails: string[] = overrideAllow
          ? overrideAllow.split(',').map((email: string) => email.trim().toLowerCase())
          : [];
        const currentUserEmail = this.userService.getUserDetails()?.email?.toLowerCase();
        if (!currentUserEmail || !allowedEmails.includes(currentUserEmail)) {
          this.buttons = this.buttons.filter(b => !['overrideTimesheet', 'overrideAllTimesheets'].includes(b.buttonAction));
        }
      }
    });
  }

  private setPageAccess() {
    const pageConfig = this.authUtility.getPageConfig(this.pageId);
    if (!pageConfig || !pageConfig.pageName) {
      this.authService.fetchPageAuthorization(this.programName, this.pageId, "LIST").subscribe(response => {
        this.setRestrictions(response);
      })
    } else {
      this.setRestrictions(pageConfig);
    }
  }

  private setRestrictions(pageConfig: PageConfig) {
    if (pageConfig) {
      this.columnsToBeHidden = this.authUtility.getHiddenColumns(pageConfig, this.pageId);
      this.actionsToBeHidden = this.authUtility.getHiddenActions(pageConfig, this.pageId);
      this.isReadOnly = this.authUtility.isRestrictiedAction(this.pageId, 'TimesheetAdjust');

      if (this.isReadOnly) {
        this.buttons = [];
      }
    }
    this.isPageRestrictionLoaded = true;
  }

  getServiceDurationFromDate(timeframe?: string): string {
    const days = parseInt(timeframe ? timeframe.substring(0, timeframe.indexOf(' ')) : '30', 10);
    const fromDate = new Date();
    fromDate.setDate(fromDate.getDate() - days);
    return this.dateTimeFormatterService.formatToString(fromDate);
  }

  loadRecordsAfterUpdate() {
    let filters = this.appliedFilters;
    if (!this.appliedFilters || this.appliedFilters.length == 0) {
      filters = [];
      filters.push({
        jsonPath: "serviceDuration",
        value: this.getServiceDurationFromDate('30 days'),
        operator: "greaterThanOrEqual"
      }, {
        jsonPath: "processStatus",
        value: 'PE',
        operator: "Equal"
      });
    }

    this.searchTimesheets(filters);
  }

  getProcessCodes() {
    this.timesheetService
      .getProcessCodes(this.programName)
      .subscribe((data: any) => {
        this.processCodes = this.sharedDataService.sortByKey(data.responsedata, 'code');
        this.processCodes.map((processCode: any) => {
          processCode.displayName = `${processCode.code.trim()} - ${processCode.desc.trim()}`;
        });
      });
  }

  buildRequestPayload(pageName: string, orderBy: string, searchParams: [], startingPageNumber = 1) {
    if (searchParams.length == 0) {
      //handle the error here
      return;
    }

    const payload: any = {
      pageName: pageName,
      programCode: this.programName,
      condition: 'and',
      recordsPerPage: 20,
      startingPageNumber: startingPageNumber,
      searchParam: searchParams,
      orderByColumn: orderBy ? [orderBy] : [],
      orderBy: ['desc'],
    };
    return payload;
  }

  searchTimesheets(filters: any, startingPageNumber = 1, currentPage = 0) {
    if (startingPageNumber == 1) {
      this.timesheets = [];
    }

    const processedPayload = this.buildRequestPayload(
      'pendManagementList',
      'timesheetLineId',
      filters,
      startingPageNumber
    );

    this.listService
      .getListData(processedPayload, 'claims')
      .subscribe((data: any) => {
        const records = this.processData(data.responsedata);
        if (startingPageNumber > 1) {
          this.timesheets = [...this.timesheets, ...records];
        } else {
          this.timesheets = records;
        }

        if (this.childComponent) {
          this.childComponent.resetPagination(startingPageNumber, currentPage);
        }
      });
  }

  processData(data: any) {
    if (data && data.length > 0) {
      data.forEach((element: any) => {
        element.payPeriod = element.payrollStart + ' - ' + element.payrollEnd;
        element.timeInTimeOut = this.dateTimeFormatterService.convertTo12HourFormat(element.timeIn) + ' - ' + this.dateTimeFormatterService.convertTo12HourFormat(element.timeOut);

        const aStatus = this.businessStatusList.find((status: any) => status.lkpValueCode === element.businessStatus);

        element.applicationStatus = aStatus ? aStatus.lkpValueName : null;
        element.processingStatusLkp = element.processStatus;

        const pStatus = this.processingStatusList.find((status: any) => status.lkpValueCode === element.processStatus);
        element.processStatus = pStatus ? pStatus.lkpValueName : null;

        element.billedUnitInHours = (element.billedUnit * 15) / 60;
        element.billRate = element.billRate ? element.billRate : null;
      });

      return data;
    }

    return data;
  }

  onPageLoad(event: any) {
    this.searchTimesheets(this.appliedFilters, event.startingPageNumber, event?.first ?? 0);
  }

  onSearch(event: any) {
    const filters = [];
    filters.push({
      jsonPath: "serviceDuration",
      value: this.getServiceDurationFromDate(event.Timeframe),
      operator: "greaterThanOrEqual"
    });

    if (event.serviceDate) {
      filters.push({
        jsonPath: "serviceDate",
        value: this.dateTimeFormatterService.formatDateToString(event.serviceDate as Date),
        operator: "Equal"
      });
    }

    if (event.payPeriod) {
      filters.push({
        jsonPath: "serviceId",
        value: event.payPeriod,
        operator: "Equal"
      });
    }

    if (event.consumer && event.consumer.trim()) {
      filters.push({
        jsonPath: "consumerName",
        value: event.consumer.trim(),
        operator: "Contains"
      });
    }

    if (event.provider && event.provider.trim()) {
      filters.push({
        jsonPath: "providerName",
        value: event.provider.trim(),
        operator: "Contains"
      });
    }

    if (event.providerPplId && event.providerPplId.trim()) {
      filters.push({
        jsonPath: "providerPPLId",
        value: event.providerPplId.trim(),
        operator: "Equal"
      });
    }

    if (event.consumerPplId && event.consumerPplId.trim()) {
      filters.push({
        jsonPath: "consumerPPLId",
        value: event.consumerPplId.trim(),
        operator: "Equal"
      });
    }

    if (event.processStatusLkup) {
      filters.push({
        jsonPath: "processStatus",
        value: event.processStatusLkup,
        operator: "Equal"
      });
    }

    if (event.serviceCode) {
      filters.push({
        jsonPath: "serviceCode",
        value: event.serviceCode,
        operator: "Equal"
      });
    }

    if (event.processCode) {
      filters.push({
        jsonPath: "processCode",
        value: event.processCode,
        operator: "Equal"
      });
    }

    if (event.paymentDate) {
      filters.push({
        jsonPath: "paymentId",
        value: event.paymentDate,
        operator: "Equal"
      });
    }

    if (event.assignedTo) {
      filters.push({
        jsonPath: "assignToName",
        value: this.getAssignToSearchValue(event.assignedTo),
        operator: "Contains"
      });
    }

    const hasRelevantFilter = filters.some(filter =>
      ["providerName", "consumerName", "providerPPLId", "consumerPPLId", "assignToName"].includes(filter.jsonPath)
    );

    if (!hasRelevantFilter) {
      this.openWarningMessage();
      return;
    }

    this.appliedFilters = filters;
    this.searchTimesheets(filters);
  }

  handlePendedTimesheet(event: any, allowEdit: boolean) {
    this.disableEditingPendedTimesheet = allowEdit;
    const timesheetLineId = event.timesheetLineId;
    console.log("timesheetLineId", timesheetLineId);
    const filters: any = [
      {
        jsonPath: "timesheetId",
        value: timesheetLineId,
        operator: "Equal"
      }
    ];
    const errorListPayload = this.buildRequestPayload(
      'timesheet-processCode', '',
      filters
    );
    this.listService
      .getListData(errorListPayload, 'claims')
      .subscribe((data: any) => {
        this.errorcodeData = data.responsedata;
        this.openPendedDialog();
      });
  }

  handlePendCodes(timesheetLineIds: any[], event: any) {
    const filters: any = [
      {
        jsonPath: "timesheetId",
        values: timesheetLineIds,
        operator: "IN"
      }
    ];
    const errorListPayload = this.buildRequestPayload(
      'pendCodes', '',
      filters
    );
    this.listService
      .getListData(errorListPayload, 'claims')
      .subscribe((data: any) => {
        this.pendCodes = this.sharedDataService.sortByKey(data.responsedata, 'code');
        this.pendCodes.map((pendCode: any) => {
          pendCode.displayName = `${pendCode.code.trim()} - ${pendCode.externalMessage.trim()}`;
        });
        this.processDataForModel(event);
      });
  }

  openPendedDialog() {
    const dialogConfig: DialogConfig = {
      title: `Pended Timesheet`,
      isOkText: 'Ok',
      size: 'x-large',
      position: 'top',
      showClose: true,
      showButtons: false,
    };

    this.pendedDialogId = this.dialogSvc.openDialog(
      this.pendedDialog,
      dialogConfig,
      () => this.handleCancel(),
      () => this.handleCancel()
    );
  }

  onSaveAdjustment(event: any) {
    this.dialogSvc.closeDialog(this.pendedDialogId);
    this.pendedDialogId = null;
    this.loadRecordsAfterUpdate();
  }

  handleCancel() {
    this.showActionPopup = false;
    this.isAssignToUser = false;
    this.selectedUsers = [];
  }

  rowClicked(event: any) {
    if (['Pended'].includes(event.processStatus)) {
      this.handlePendedTimesheet(event, false);
    }
    else if (CommonUtil.hasInfoStatus(event.processStatus)) {
      this.handlePendedTimesheet(event, true);
    }
  }

  isValidStatusSelection(selectedCheckBox: any[], allowedStatuses: string[]): boolean {
    return selectedCheckBox.every((e: any) => allowedStatuses.includes(e.processingStatusLkp));
  }

  isFilterValid(timesheetFilterValues: any, searchCallbackFilterValues: any) {
    return Object.entries(timesheetFilterValues)
      .filter(([_, value]) => value !== null && value !== "")
      .every(([key, value]) => {
        const mappedKey = this.keyMapping[key] || key;
        let comparisonValue = value;
        if (mappedKey === 'serviceDate') {
          comparisonValue = this.dateTimeFormatterService.formatDateToString(value as Date);
        } else if (mappedKey === 'assignToName') {
          comparisonValue = this.getAssignToSearchValue(value as string);
        } else if (mappedKey === 'serviceDuration') {
          comparisonValue = this.getServiceDurationFromDate(value as string);
        }

        return searchCallbackFilterValues.some((filter: any) => filter.jsonPath === mappedKey && filter.value === comparisonValue);
      });
  }

  action(event: any) {
    if (event.action === 'history') {
      this.openHistoryDialog(event.data.timesheetLineId);
    }
  }

  openHistoryDialog(timesheetLineId: any) {
    this.timesheetService.getTimesheetHistory(this.programName, timesheetLineId).subscribe((data: any) => {
      this.timesheetHistoryData = (data.responsedata || []).map((item: any) => ({
        ...item,
        processingStatusDisplay: item.processingStatus,
        businessStatusDisplay: item.businessStatus,
        modifiedDate: this.formatHistoryDate(item.modifiedDate)
      }));
      const dialogConfig: DialogConfig = {
        title: 'Timesheet History',
        isOkText: 'Ok',
        size: 'large',
        position: 'top',
        showClose: true,
        showButtons: false,
        styleClass: 'split-auth-data',
      };

      this.dialogSvc.openDialog(
        this.historyDialog,
        dialogConfig,
        () => this.handleCancel(),
        () => this.handleCancel()
      );
    });
  }

  formatHistoryDate(value: any): any {
    if (!value) {
      return value;
    }
    const date = new Date(value);
    return isNaN(date.getTime()) ? value : this.dateTimeFormatterService.formatDateTimeNoSeconds(value);
  }

  gridAction(event: any) {
    this.buttonActionEvent = event.button;
    this.selectedCheckboxes = event.selectedCheckBox;
    this.timesheetActionForm.reset();
    this.totalTimesheetsEffected = 0;
    this.isAssignToUser = false;

    if (!this.isFilterValid(this.timesheetFilterChildComponent.timesheetSearchForm.value, this.appliedFilters)) {
      const errorMessage = `Some filters are newly applied but the search is not performed. Kindly perform search with updated filter or remove the filter.`;
      this.errorAlertService.openModal('error', 'Error', errorMessage);
      return;
    }

    if (['denyTimesheet', 'denyAllTimesheet'].includes(event.button.buttonAction) && !this.isValidStatusSelection(event.selectedCheckBox, this.denyAllowedStatuses)) {
      const errorMessage = 'Please select only Pending or Submitted or System Error timesheets.';
      this.errorAlertService.openModal('error', 'Error', errorMessage);
      return;
    }

    if (['overrideTimesheet', 'overrideAllTimesheets'].includes(event.button.buttonAction) && !this.isValidStatusSelection(event.selectedCheckBox, this.overrideAllowedStatuses)) {
      const errorMessage = 'Please select only Pending or System Error timesheets.';
      this.errorAlertService.openModal('error', 'Error', errorMessage);
      return;
    }

    if (["denyAllTimesheet", "overrideAllTimesheets"].includes(event.button.buttonAction)) {
      if (this.appliedFilters) {
        const filterJsonPaths = this.appliedFilters.map((entry: any) => entry.jsonPath);
        const hasBaseFiltersApplied = filterJsonPaths.includes('serviceDuration') && filterJsonPaths.includes('processStatus');
        const hasUserFiltersApplied = filterJsonPaths.includes('consumerName') || filterJsonPaths.includes('consumerPPLId') || filterJsonPaths.includes('providerName') || filterJsonPaths.includes('providerPPLId');
        const optionalFiltersApplied = filterJsonPaths.includes('serviceId') || filterJsonPaths.includes('paymentId') || filterJsonPaths.includes('serviceCode') || filterJsonPaths.includes('processCode');

        if (!hasBaseFiltersApplied) {
          const errorMessage = `Please select the Service Duration and Process Status to continue with this action.`;
          this.errorAlertService.openModal('error', 'Error', errorMessage);
          return;
        }

        if (!hasUserFiltersApplied && !optionalFiltersApplied) {
          const errorMessage = `Please select at least one filter (Consumer, Provider, Service ID, or Payment ID) to continue with this action.`;
          this.errorAlertService.openModal('error', 'Error', errorMessage);
          return;
        }
      }
      this.openConfirmationPopup(event);
    }
    else if (event.button.buttonAction == 'submitForProcessing') {
      this.handleSubmitForProcessing(event);
    }
    else if (event.button.buttonAction === 'assignToUser') {
      this.handleAssignToUser(event);
    }
    else {
      this.handlePendCodes(event.selectedCheckBox.map((e: any) => e.timesheetLineId), event);
    }
  }

  handleSubmitForProcessing(event: any) {
    const totalInvalidProcessSelected = event.selectedCheckBox.filter((e: any) => e.processingStatusLkp != 'PE' && e.processingStatusLkp != 'SB' && e.processingStatusLkp != 'SE');
    if (totalInvalidProcessSelected.length > 0) {
      const errorMessage = 'Please select only Pending or Submitted or System Error timesheets.';
      this.errorAlertService.openModal('error', 'Error', errorMessage);
      return;
    }

    const selectedIds = event.selectedCheckBox.map((item: any) => item.timesheetLineId);
    const payload =
    {
      "programCode": this.programName,
      "timesheetlineDetailIds": selectedIds
    };

    this.timesheetService.updateTimesheetAdjudication(payload).subscribe((data: any) => {
      if (data.status === 200) {
        this.loadRecordsAfterUpdate();
      }
    });
  }

  processDataForModel(event: any) {
    if (event.button.buttonAction.toLowerCase() == "overrideTimesheet".toLowerCase()) {
      this.allowedProcessCodes = this.pendCodes.filter(e => e.allowOverride);
    } else if (event.button.buttonAction.toLowerCase() == "overrideAllTimesheets".toLowerCase()) {
      this.allowedProcessCodes = this.processCodes.filter(e => e.allowOverride);
    }
    else if (event.button.buttonAction.toLowerCase() == "denyAllTimesheet".toLowerCase()) {
      this.allowedProcessCodes = this.processCodes;
    }
    else {
      this.allowedProcessCodes = this.pendCodes;
    }

    this.reasonList = ["overrideTimesheet", "overrideAllTimesheets"].includes(event.button.buttonAction)
      ? this.overrideReasonList
      : this.denyReasonList;

    this.setupModal(event.button.button_label);
  }

  openConfirmationPopup(event: any) {
    const dialogConfig: DialogConfig = {
      title: 'Confirmation',
      isOkText: 'Confirm',
      size: 'medium',
      position: 'top',
      showClose: true,
      showButtons: true,
    };

    this.dialogSvc.openDialog(
      this.confirmationDialog,
      dialogConfig,
      () => this.processDataForModel(event),
      () => this.handleCancel()
    );
  }

  openWarningMessage() {
    const dialogConfig: DialogConfig = {
      title: 'Error',
      showOkButton: true,
      isOkText: 'Ok',
      size: 'medium',
      position: 'top',
      showButtons: false,
    };

    this.dialogSvc.openDialog(
      this.warningDialog,
      dialogConfig,
      () => this.handleCancel(),
      () => this.handleCancel()
    );
  }

  handleOk() {
    if (this.buttonActionEvent.buttonAction === 'assignToUser') {
      const selectedUserValues = Array.isArray(this.selectedUsers)
        ? this.selectedUsers
        : [this.selectedUsers];
      if (!selectedUserValues.length) {
        this.errorAlertService.openModal('error', 'Error', 'Please select a user to complete this action.');
        return;
      }
      const userMap = new Map<string, number>(
        this.userList.responsedata.map((user: any) => [
          `${user.firstName} ${user.lastName}`,
          user.userId,
        ])
      );
      const userIds = selectedUserValues
        .map((name: string) => userMap.get(name))
        .filter((id): id is number => id !== undefined);
      const payload = {
        ids: this.selectedCheckboxes.map((e: any) => e.timesheetLineId),
        selectedUsers: userIds,
        type: 'tmshts',
        programCode: this.programName,
      };
      this.listService.assignUser(payload).subscribe((data: any) => {
        if (data.status === 200) {
          this.showActionPopup = false;
          this.notificationService.alert(
            'success',
            'Success',
            'Assigned to user successfully'
          );
          this.loadRecordsAfterUpdate();
        }
      });
      return;
    }

    if (this.timesheetActionForm.invalid) {
      this.timesheetActionForm.markAllAsTouched();
      return;
    }

    const payload: any = {};
    let urlEndpoint = '';
    payload.processCode = [];
    const formValues = this.timesheetActionForm.value;
    formValues.selectedProcessCode?.forEach((code: string) => {
      let requiredCode = [];
      if (this.pendCodes && this.pendCodes.length) {
        requiredCode = this.pendCodes.filter(e => e.code == code);
      } else {
        requiredCode = this.processCodes.filter(e => e.code == code);
      }
      if (requiredCode && requiredCode.length) {
        payload.processCode.push({ code: requiredCode[0].processCodeId || requiredCode[0].processCodeDetailId, reasonLkp: formValues.reason, comments: formValues.comments });
      }
    });
    let placeholder = '';
    switch (this.buttonActionEvent.buttonAction) {
      case 'denyTimesheet': {
        urlEndpoint = ENDPOINTS.CLAIMS.POST_DENY_TIMESHEET;
        placeholder = 'denied';
        payload.timesheetLine = this.selectedCheckboxes.map((value: any) => value.timesheetLineId);
        break;
      }
      case 'overrideTimesheet': {
        urlEndpoint = ENDPOINTS.CLAIMS.POST_OVERRIDE_TIMESHEET;
        placeholder = 'overridden';
        payload.timesheetLine = this.selectedCheckboxes.map((value: any) => value.timesheetLineId);
        break;
      }
      case 'denyAllTimesheet': {
        placeholder = 'denied';
        urlEndpoint = ENDPOINTS.CLAIMS.POST_DENY_ALL_TIMESHEET;
        payload.searchParam = this.appliedFilters;
        break;
      }
      case 'overrideAllTimesheets': {
        placeholder = 'overridden';
        urlEndpoint = ENDPOINTS.CLAIMS.POST_OVERRIDE_ALL_TIMESHEET;
        payload.searchParam = this.appliedFilters;
        break;
      }
    }

    this.timesheetService.denyOverrideTimesheet(urlEndpoint, this.programName, payload, placeholder)
      .subscribe((data: any) => {
        this.showActionPopup = false;
        this.loadRecordsAfterUpdate();
      });
  }

  handleAssignToUser(event: any) {
    this.timesheetService.getUserList(this.programName).subscribe((data: any) => {
      this.userList = data;
      this.listOfUsers = data.responsedata.map(
        (user: any) => `${user.firstName} ${user.lastName}`
      );
    });
    this.isAssignToUser = true;
    this.selectedUsers = [];
    this.title = 'Assign to User';
    this.okText = 'Assign';
    this.showActionPopup = true;
  }

  setupModal = (
    label: string,
  ) => {
    this.title = label;
    this.okText = label;
    this.placeholder = `Select ${label.toLowerCase()} reason.`;
    this.showActionPopup = true;
  };
}
